import addCommasToNumber from './addCommasToNumber';
import capitalize from './capitalize';
import currencyFormat from './currencyFormat';
import dateFormat from './dateFormat';
import isMobileDevice from './isMobileDevice';
import promptLogin from './promptLogin';
import removeCommasFromNumber from './removeCommasFromNumber';


const exported = {
  addCommasToNumber,
  capitalize,
  currencyFormat,
  dateFormat,
  isMobileDevice,
  promptLogin,
  removeCommasFromNumber,
};

export default exported;

export { addCommasToNumber, capitalize, currencyFormat, dateFormat, isMobileDevice, promptLogin, removeCommasFromNumber };

